//const isPage = slug => document.body.classList.contains(slug);
export var UIController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initScrollTop();
                _this.initBlurMainMenu();
                //this.initBeeFollowCursor();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initBlurMainMenu: function () {
        var header = document.querySelector('.header');
        if (!header)
            return;
        window.addEventListener('scroll', function () {
            if (window.scrollY > 160)
                header.classList.add('nav-blur');
            else
                header.classList.remove('nav-blur');
        });
    },
    initScrollTop: function () {
        var scrollToTopButton = document.querySelector('.scroll-top-arrow-button');
        scrollToTopButton === null || scrollToTopButton === void 0 ? void 0 : scrollToTopButton.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        window.addEventListener('scroll', function () {
            if (window.scrollY > 400) {
                scrollToTopButton === null || scrollToTopButton === void 0 ? void 0 : scrollToTopButton.classList.add('visible');
            }
            else {
                scrollToTopButton === null || scrollToTopButton === void 0 ? void 0 : scrollToTopButton.classList.remove('visible');
            }
        });
    },
    initBeeFollowCursor: function () {
        var bee = document.querySelector('.cursor__bee-flying');
        if (!bee)
            return;
        // ===== CONFIG =====
        var speedMinMouse = 0.05; // smooth on desktop
        var speedMaxMouse = 0.18; // boost speed on desktop
        var speedMinTouch = 0.12; // smooth on mobile
        var speedMaxTouch = 0.35; // boost speed on mobile
        var rotateSpeed = 0.18; // rotation smoothing (smaller = smoother)
        var tiltStrength = 12; // max tilt angle (degrees)
        var followRadius = 80; // distance to avoid sticking to cursor/finger
        // Current value: -90 (bee sprite points up by default)
        var angleOffsetDeg = 0;
        // ==================
        // Target position (cursor/finger)
        var targetX = window.innerWidth / 2;
        var targetY = window.innerHeight / 2;
        // Current bee position
        var beeX = targetX;
        var beeY = targetY;
        // Smooth rotation state
        var currentAngle = 0;
        // Used for tilt and movement direction
        var lastBeeX = beeX;
        var lastBeeY = beeY;
        // Current flip value (1 or -1)
        var flipX = 1;
        // Detect touch device (mobile)
        var isTouchDevice = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
        var usingTouch = false;
        var clamp = function (value, min, max) { return Math.max(min, Math.min(max, value)); };
        var normalizeAngle = function (a) {
            while (a > Math.PI)
                a -= Math.PI * 2;
            while (a < -Math.PI)
                a += Math.PI * 2;
            return a;
        };
        // Desktop (mouse)
        window.addEventListener('mousemove', function (e) {
            usingTouch = false;
            targetX = e.clientX;
            targetY = e.clientY;
        });
        // Mobile (touch)
        var handleTouch = function (e) {
            var _a;
            var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
            if (!touch)
                return;
            usingTouch = true;
            targetX = touch.clientX;
            targetY = touch.clientY;
        };
        if (isTouchDevice) {
            window.addEventListener('touchstart', handleTouch, { passive: true });
            window.addEventListener('touchmove', handleTouch, { passive: true });
        }
        var animateBee = function () {
            // Distance between target and bee
            var dx = targetX - beeX;
            var dy = targetY - beeY;
            var dist = Math.sqrt(dx * dx + dy * dy);
            // Smart acceleration based on distance
            var speedMin = usingTouch ? speedMinTouch : speedMinMouse;
            var speedMax = usingTouch ? speedMaxTouch : speedMaxMouse;
            var t = clamp(dist / 500, 0, 1);
            var followSpeed = speedMin + (speedMax - speedMin) * t;
            // Offset target so the bee doesn't stick exactly to cursor/finger
            var desiredX = targetX;
            var desiredY = targetY;
            if (dist > 0.001) {
                desiredX = targetX - (dx / dist) * followRadius;
                desiredY = targetY - (dy / dist) * followRadius;
            }
            // Move with delay + acceleration
            beeX += (desiredX - beeX) * followSpeed;
            beeY += (desiredY - beeY) * followSpeed;
            // Movement direction
            var moveDX = beeX - lastBeeX;
            var moveDY = beeY - lastBeeY;
            // Avoid jitter when almost stopped
            var moving = Math.abs(moveDX) + Math.abs(moveDY) > 0.05;
            if (moving) {
                // 1) Decide whether to flip (when moving left)
                flipX = (moveDX < 0 ? -1 : 1);
                // 2) Calculate angle consistently:
                var dxForAngle = Math.abs(moveDX);
                var dyForAngle = flipX === -1 ? -moveDY : moveDY;
                var angleOffsetRad = (angleOffsetDeg * Math.PI) / 180;
                var targetAngle = Math.atan2(dyForAngle, dxForAngle) + angleOffsetRad;
                var diff = normalizeAngle(targetAngle - currentAngle);
                currentAngle = currentAngle + diff * rotateSpeed;
            }
            // Tilt (inertia) based on horizontal movement
            var tilt = clamp(moveDX * 1.2, -tiltStrength, tiltStrength);
            // Apply transform:
            bee.style.left = "".concat(beeX, "px");
            bee.style.top = "".concat(beeY, "px");
            bee.style.transform = "translate(-50%, -50%) scaleX(".concat(flipX, ") rotate(").concat(currentAngle, "rad) rotateZ(").concat(tilt, "deg)");
            lastBeeX = beeX;
            lastBeeY = beeY;
            requestAnimationFrame(animateBee);
        };
        animateBee();
    },
};
